/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type AlertsPage_allWarnings$ref = any;
type DropdownCategories_allCategories$ref = any;
export type queries_AlertsPage_recipes_QueryVariables = {||};
export type queries_AlertsPage_recipes_QueryResponse = {|
  +allCategories: ?{|
    +$fragmentRefs: DropdownCategories_allCategories$ref
  |},
  +$fragmentRefs: AlertsPage_allWarnings$ref,
|};
export type queries_AlertsPage_recipes_Query = {|
  variables: queries_AlertsPage_recipes_QueryVariables,
  response: queries_AlertsPage_recipes_QueryResponse,
|};
*/


/*
query queries_AlertsPage_recipes_Query {
  allCategories {
    ...DropdownCategories_allCategories
  }
  ...AlertsPage_allWarnings
}

fragment AlertsPage_allWarnings on Query {
  allWarnings(first: 20) {
    totalCount
    edges {
      node {
        id
        slugName
        description
        icon
        __typename
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}

fragment DropdownCategories_allCategories on RecipeCategoryNodeConnection {
  edges {
    node {
      id
      name
      picture
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 20
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "queries_AlertsPage_recipes_Query",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "RecipeCategoryNodeConnection",
        "kind": "LinkedField",
        "name": "allCategories",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "DropdownCategories_allCategories"
          }
        ],
        "storageKey": null
      },
      {
        "args": null,
        "kind": "FragmentSpread",
        "name": "AlertsPage_allWarnings"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "queries_AlertsPage_recipes_Query",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "RecipeCategoryNodeConnection",
        "kind": "LinkedField",
        "name": "allCategories",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "RecipeCategoryNodeEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "RecipeCategoryNode",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v0/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "name",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "picture",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "WarningNodeConnection",
        "kind": "LinkedField",
        "name": "allWarnings",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "totalCount",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "WarningNodeEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "WarningNode",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v0/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "slugName",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "description",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "icon",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "__typename",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "cursor",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "PageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "endCursor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasNextPage",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": "allWarnings(first:20)"
      },
      {
        "alias": null,
        "args": (v1/*: any*/),
        "filters": [
          "slugName"
        ],
        "handle": "connection",
        "key": "Alerts_allWarnings",
        "kind": "LinkedHandle",
        "name": "allWarnings"
      }
    ]
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "queries_AlertsPage_recipes_Query",
    "operationKind": "query",
    "text": "query queries_AlertsPage_recipes_Query {\n  allCategories {\n    ...DropdownCategories_allCategories\n  }\n  ...AlertsPage_allWarnings\n}\n\nfragment AlertsPage_allWarnings on Query {\n  allWarnings(first: 20) {\n    totalCount\n    edges {\n      node {\n        id\n        slugName\n        description\n        icon\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n\nfragment DropdownCategories_allCategories on RecipeCategoryNodeConnection {\n  edges {\n    node {\n      id\n      name\n      picture\n    }\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'c0c66c33ca32b24ca1c74783f8ee68b2';

module.exports = node;
